import React from 'react';
import {Link} from 'react-router-dom';
import {ArrowLeftIcon} from '@heroicons/react/24/outline';

interface IButtonBackProps {
  url?: string;
}

const ButtonBack = ({url}: IButtonBackProps) => {
  const className = 'inline-flex items-center gap-1.5 text-primary pr-2 hover:brightness-120';
  const content = (
    <>
      <ArrowLeftIcon className="size-4" />
      <p className="font-semibold">Back</p>
    </>
  );
  if (url) {
    return (
      <Link to={url} className={className}>
        {content}
      </Link>
    );
  }
  return (
    <button type="button" className={className}>
      {content}
    </button>
  );
};

export default React.memo(ButtonBack);
